export default __webpack_public_path__ + "static/media/img (1).5b45dfdd.jpg";